<html lang="en">
<head>
  <meta charset="utf-8"/>
  <meta content="width=device-width, initial-scale=1.0" name="viewport"/>
  <title>Dashboard</title>
  <script src="https://cdn.tailwindcss.com"></script>
  <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css" rel="stylesheet"/>
  <style>
    
  </style>
</head>

<body class="text-white p-8 flex flex-col h-screen">
  <app-reboot-controller class="reboot-pop-up" [showRebootPopup]="showRebootPopup" *ngIf="showRebootPopup && !showCustomerPopUp" (closeModal) = "closeModal()" [controllerDetails]="controllerDetails" ></app-reboot-controller>
  <app-customer-card *ngIf="showCustomerPopUp" class="customer-card" (closeModal)="closeModal()"></app-customer-card>
  

  <div class="container-fluid">
    <div class="row gx-0">
      <div class="col-lg-12 d-flex" >

  <div class="side-menu">
    <app-side-bar></app-side-bar>
  </div>

<div class="right-side">
<!-- USER PROFILE HEADER -->
<div class="profile-card">

  <img alt="User Avatar"
        class="profile-pic"
        height="60"
        width="60"
      [src]="profileImage" (click)="onProfileTap()" />
        <div class="profile-info">

    <h2 class="profile-name">{{fullName}}</h2>
    <!-- <h2 class="text-xl font-semibold">{{userId}}</h2> -->
    <p class="profile-email">{{userName}}</p>
  </div>
</div>


<div class="pagination-block">
  <p-breadcrumb class="max-w-full" [model]="items" />
</div>

  <ng-container *ngIf="streamCalled; else showController">

                    <div
                      class="loader-container"
                    >
                      <span class="loader-controller"></span>
                    </div>
    </ng-container>

<ng-template #showController>
<!-- CONTROLLER TABS -->
<div class="controller-container" >
<div class="flex gap-4 mb-6" style="display: flex;flex-wrap: nowrap;" >

 <div
  *ngFor="let item of paginatedInfo; let i = index"
  (click)="selectTab((currentPage - 1) * itemsPerPage + i)"
  class="controller-container"
  [ngClass]="{
    'selected': ((currentPage - 1) * itemsPerPage + i) === selectedTabIndex,
    'bg-gray-800 text-gray-300': ((currentPage - 1) * itemsPerPage + i) !== selectedTabIndex
  }"
>
   <div class="tab-label">
    <div class="el"></div>
    <div class="lef"></div>




      <ng-container *ngIf="get_controller_status(item.controller_uuid) === 'online'; else offlineBlock">
        <span class="controller-status on-status"></span>
        {{ item.controller_tag }}
      </ng-container>

      <ng-template #offlineBlock>
        <span class="controller-status off-status"></span>
        {{ item.controller_tag }}
      </ng-template>
    <div class="controller-settings"><img src="assets/img/Group.svg" alt="" (click)="reboot(item.controller_tag,item.controller_uuid)"></div>
    </div>
  </div>
  
  <div>

  </div>
</div>



<!-- DEVICE CARDS UNDER SELECTED CONTROLLER -->
<div *ngIf="deviceUnderController.length > 0" class="controller-content grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 p-5">
  <div
    *ngFor="let device of deviceUnderController"
    class="device rounded-2xl shadow p-3"
    (click)="onDeviceClick(device.device_id, device.controller_uuid)"
  >

      <div class="device-status-figure">
        <ng-container *ngIf="statusLoading; else showImage">
          <div class="loader"></div>
          </ng-container>
      
        <ng-template #showImage>
          <ng-container *ngIf="getDeviceImage(device.device_id, device.controller_uuid) as deviceImg">
            <img 
              [src]="deviceImg.src" 
              [alt]="deviceImg.alt"
              class="w-[70px] h-[60px] ml-[170px]" 
            />
          </ng-container>
        </ng-template>
      </div>

  <div style="display: flex;justify-content: center;margin: auto;">
    <img
        [src]="getImagePath(device.device_id)"
        width="70"
        height="90"
        alt="device"
      />
    </div>

    <div class=responsive-text>{{ device.device_id }}</div>

<div class="status-icons">
    <div class="alarm-figure">
      <img 
      *ngIf="device.has_alarms" 
      src="assets/img/danger.svg" 
      alt="Danger" 
      style="width: 20px; height: 40px;" 
      (click)="alarmHistory(device)"
    />
    <img 
    *ngIf="shouldShowScheduleIcon(device.device_id); else placeholder" 
    src="assets/img/schedule-on.svg" 
    alt="Schedule On" 
    class="w-5 h-10 ml-2"
  />
  <ng-template #placeholder>
    <img 
      src="assets/img/schedule-on.svg" 
      alt="Schedule Placeholder" 
      class="w-5 h-10 ml-2 invisible"
    />
  </ng-template>

      </div>
      </div>



  </div>
</div>
</div>
<!-- NO DEVICES MESSAGE -->


 
<div *ngIf="deviceUnderController.length === 0" class="text-gray-400 h-50 grey-box-container text-center">
    <div class="no-device-block">
      <img src="assets/img/no-device-ico.svg" alt="No devices" width="80" />
      <p class="no-device-label">No devices available for this controller.</p>
    </div>
</div>

        <div
          class="text-center d-flex justify-content-center dashboard-pagination"
        >

          <ngb-pagination
            [(page)]="currentPage"
            [pageSize]="itemsPerPage"
            [collectionSize]="controllerList.length"
            (pageChange)="pageChanged($event)"
            style="z-index: 0"
          ></ngb-pagination>

          </div>


</ng-template>
</div> 

</div>
</div>
</div>



</body>
</html>